import { isValidEmail } from '../../../utils/validations';

const validateEmail = (email: string) => {
  // validation happens only if email is not empty
  if (!email || isValidEmail(email)) return undefined;

  return 'Zadejte platný email';
};
export default validateEmail;
